import { AcademicLevel, Department, Email, FirstName, LastName, MobilePhoneRequired, Salutation, Section, Consentement } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Consentement,
  schools: Yup.array().min(1, 'Veuillez sélectionner au moins une école. Si vous ne savez pas encore, cochez les 4 écoles.'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Department,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Salutation,
    ...Section
  })
})

export default schema
